<template>
   <div id="postergl">
       <div class="tos">
          <el-form :inline="true" :model="posterPageDto" label-width="100px"  class="demo-form-inline">
             <el-form-item label="关键字：">
                <el-input v-model="posterPageDto.keyWord"></el-input>
             </el-form-item>
             <el-form-item>
                <el-button type="primary" plain @click="sjhsearchFor(posterPageDto.keyWord)">查询</el-button>
             </el-form-item>
          </el-form>
          <el-button class="right-item"  type="primary" @click=newoks()>添加海报</el-button>
       </div>
       <div class="tableform">
         <el-table
             :data="tableData"
             border
             stripe
             :cell-style="{'text-align':'center'}"
             :header-cell-style="{'background-color': '#eef1f6','text-align':'center'}"
             style="width: 100%">
             <el-table-column
                prop="posterDesc"
                label="海报描述"
                >
                <template slot-scope="{row:{ posterDesc }}">
                {{ posterDesc|| "—" }}
                </template>
             </el-table-column>
             <el-table-column
                prop="count"
                label="商品数量"
                >
                <template slot-scope="{row:{ count }}">
                {{ count|| "—" }}
                </template>
             </el-table-column>
             <el-table-column
                prop="mainImgUrl"
                label="图片"
                >
                <template slot-scope="scope">
                  <img :src="scope.row.mainImgUrl" class="image-column" @click="handlePreview(scope.row)" />
               </template>
             </el-table-column>
             <el-table-column
                prop="remark"
                label="备注信息"
                >
                <template slot-scope="{row:{ remark }}">
                {{ remark|| "—" }}
                </template>
             </el-table-column>
             <el-table-column fixed="right" label="操作" width="280">
                <template slot-scope="scope">
                     <i title="编辑" class="el-icon-alixiugai" style="color: #1296db;cursor: pointer;"  @click=bianjiClick(scope.row) ></i>
                     <i title="删除" class="el-icon-alishanchu" style="color: #d81e06;cursor: pointer;"  @click=dels(scope.row) ></i>
                </template>
             </el-table-column>
          </el-table>
          <div class="btnbox">
             <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="posterPageDto.pageNum"
                :page-sizes="[10, 15, 20]"
                :page-size="posterPageDto.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="this.totals">
             </el-pagination>
          </div>
       </div>
       <!-- 添加海报弹框 -->
       <el-dialog title="添加海报" :visible.sync="increase" width="32%" class="zcyhtk"  @close='closeDialog'>
            <el-form ref="operatorPosterDto" :model="operatorPosterDto" :rules="zcrules" label-width="80px" label-position="right" size="small">
               <el-form-item label="海报描述：">
                    <el-input v-model="operatorPosterDto.posterDesc" placeholder="请输海报描述"></el-input>
                </el-form-item>
               <el-form-item label="序号：">
                  <el-radio-group v-model="operatorPosterDto.posterSort">
                  <el-radio label="1">1</el-radio>
                  <el-radio label="2">2</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="备注信息：">
                    <el-input v-model="operatorPosterDto.remark" placeholder="请输入备注"></el-input>
                </el-form-item>
                <el-form-item label="配件主图：">
                  <el-upload
                     class="upload-demo"
                     action="#"
                     ref="upload"
                     :limit="1"
                     :http-request="handleRequest"
                     :on-remove="handleRemove"
                     :before-upload="beforeUpload"
                     :on-success="handleSuccess"
                     :on-error="handleError"
                     :on-exceed="handleExceed"
                     list-type="picture-card"
                     :file-list="fileList"
                  >
                  <i class="el-icon-plus"></i>
                  <div class="el-upload__tip" slot="tip">图片尺寸建议329px*177px</div>
                  </el-upload>
               </el-form-item>
               <el-form-item label="添加产品：">
                  <el-input placeholder="请输入产品名称" v-model="fyposterPageDto.keyWord">
                     <template #suffix >
                        <div @click="xxzjdan">
                           <el-icon style="cursor: pointer;padding-right: 10px;margin-top: 6px;font-size: 20px; color: black;" name="search"></el-icon>
                        </div>
                     </template>
                  </el-input>
               </el-form-item>
               <div class="fytableform">
                  <el-table
                     ref="multipleTable"
                     :data="fytableData"
                     border
                     stripe
                     :row-key=" row => row.productId"
                      @selection-change="handlepartsIdsClick"
                     :cell-style="{'text-align':'center'}"
                     :header-cell-style="{'background-color': '#eef1f6','text-align':'center'}"
                     style="width: 100%">
                     <el-table-column
                        prop="productImageUrl"
                        label="商品图片"
                        >
                        <template slot-scope="scope">
                              <img :src="scope.row.productImageUrl" class="image-column" />
                           </template>
                     </el-table-column>
                     <el-table-column
                        prop="productTitle"
                        label="产品名称"
                        >
                        <template slot-scope="{row:{ productTitle }}">
                        {{ productTitle|| "—" }}
                        </template>
                     </el-table-column>
                     <el-table-column
                        prop="priceRange"
                        label="价格区间"
                        >
                        <template slot-scope="{row:{ priceRange }}">
                        {{ priceRange|| "—" }}
                        </template>
                     </el-table-column>
                     <el-table-column
                           type="selection"
                           reserve-selection
                           width="55">
                        </el-table-column>
                  </el-table>
                  <div class="btnbox">
                     <el-pagination
                          @size-change="fyhandleSizeChange"
                        @current-change="fyhandleCurrentChange"
                        :current-page="fyposterPageDto.pageNum"
                        :page-sizes="[10, 15, 20]"
                        :page-size="fyposterPageDto.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="this.fytotals">
                     </el-pagination>
                  </div>
               </div>
               </el-form>
            <div slot="footer">
                <el-button @click="increase = false">取 消</el-button>
                <el-button type="primary"  @click="submitForm('operatorPosterDto',operatorPosterDto)">确 定</el-button>
            </div>
       </el-dialog>
       <!-- 修改弹框 -->
       <el-dialog title="编辑海报" :visible.sync="dialogFormVisible" width="32%" class="zcyhtk"  @close='closeDialog'>
         <el-form ref="operatorPosterDto" :model="operatorPosterDto" :rules="zcrules" label-width="80px" label-position="right" size="small">
               <el-form-item label="海报描述：">
                    <el-input v-model="operatorPosterDto.posterDesc" placeholder="请输海报描述"></el-input>
                </el-form-item>
               <el-form-item label="序号：">
                  <el-radio-group v-model="operatorPosterDto.posterSort">
                  <el-radio label="1">1</el-radio>
                  <el-radio label="2">2</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="备注信息：">
                    <el-input v-model="operatorPosterDto.remark" placeholder="请输入备注"></el-input>
                </el-form-item>
                <el-form-item label="海报图片：">
                  <el-upload
                     class="upload-demo"
                     action="#"
                     ref="upload"
                     :limit="1"
                     :http-request="handleRequest"
                     :on-remove="handleRemove"
                     :before-upload="beforeUpload"
                     :on-success="handleSuccess"
                     :on-error="handleError"
                     :on-exceed="handleExceed"
                     list-type="picture-card"
                     :file-list="fileList"
                  >
                  <i class="el-icon-plus"></i>
                  <div class="el-upload__tip" slot="tip">图片尺寸建议329px*177px</div>
                  </el-upload>
               </el-form-item>
               <el-form-item label="添加产品：">
                  <el-input placeholder="请输入产品名称" v-model="fyposterPageDto.keyWord">
                     <template #suffix >
                        <div @click="xxzjdan">
                           <el-icon style="cursor: pointer;padding-right: 10px;margin-top: 6px;font-size: 20px; color: black;" name="search"></el-icon>
                        </div>
                     </template>
                  </el-input>
               </el-form-item>
               <div class="fytableform">
                  <el-table
                     ref="multipleTable"
                     :data="fytableData"
                      v-model="selectedRows"
                     border
                     stripe
                     :row-key=" row => row.productId"
                      @selection-change="handlepartsIdsClick"
                     :cell-style="{'text-align':'center'}"
                     :header-cell-style="{'background-color': '#eef1f6','text-align':'center'}"
                     style="width: 100%">
                     <el-table-column
                        prop="productImageUrl"
                        label="商品图片"
                        >
                        <template slot-scope="scope">
                              <img :src="scope.row.productImageUrl" class="image-column" />
                           </template>
                     </el-table-column>
                     <el-table-column
                        prop="productTitle"
                        label="产品名称"
                        >
                        <template slot-scope="{row:{ productTitle }}">
                        {{ productTitle|| "—" }}
                        </template>
                     </el-table-column>
                     <el-table-column
                        prop="priceRange"
                        label="价格区间"
                        >
                        <template slot-scope="{row:{ priceRange }}">
                        {{ priceRange|| "—" }}
                        </template>
                     </el-table-column>
                     <el-table-column
                        type="selection"
                        reserve-selection
                        width="55">
                     </el-table-column>
                  </el-table>
                  <div class="btnbox">
                     <el-pagination
                          @size-change="fyhandleSizeChange"
                        @current-change="fyhandleCurrentChange"
                        :current-page="fyposterPageDto.pageNum"
                        :page-sizes="[10,15,20]"
                        :page-size="fyposterPageDto.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="this.fytotals">
                     </el-pagination>
                  </div>
               </div>
               </el-form>
            <div slot="footer">
                <el-button @click="xgtkdfdqx">取 消</el-button>
                <el-button type="primary"  @click="submitForm('operatorPosterDto',operatorPosterDto)">确 定</el-button>
            </div>
       </el-dialog>
        <!-- 大图查看弹窗 -->
        <el-dialog
          v-model="dialogVisible" title="查看大图" :visible.sync="dialogVisible" width="30%"
        >
          <img :src="previewImage" alt="大图" style="width: 100%;" />
        </el-dialog>
   </div>
   </template>
   <script>
   import ipConfig from "../../utils/ipconfig";
   import Compressor from 'compressorjs';
      export default {
      name:'postergl',
      data(){
       return{
          posterPageDto:{
             pageNum:1,
             pageSize:10,
             keyWord:null,
          },
          fyposterPageDto:{
             pageNum:1,
             pageSize:10,
             keyWord:null,
          },
          tableData: [],
          fytableData: [],
          totals:10,
          fytotals:10,
          increase:false,
          dialogFormVisible:false,
          operatorPosterDto:{
            fileId:null,
            mainImgUrl:null,
            posterDesc:null,
            posterId:null,
            posterSort:'1',
            productIds:[],
            remark:null,
         },
         fileList:[],
         zcrules: {
            position: [
            { required: true, message: '请选择引导语位置', trigger: 'blur' },
            // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
            ],
            guidanceContent: [
            { required: true, message: '请输入引导语内容', trigger: 'blur' },
            // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
            ],
         },
         selectedRows: [],
         posterIdbzdid:null,
         dialogVisible: false,
         previewImage: '', // 用于存储点击图片后展示的大图 URL
       }
      },
      created(){
       this.getlist(this.posterPageDto)
      },
      mounted(){
      },
      methods:{
       getlist(posterPageDto) {
          this.$api.queryPagelist(posterPageDto)
          .then((res) => {
                if (res.data.code == 200) {
                  let data = res.data.data.records
                  data.forEach(element => {
                     if (element.mainImgUrl.startsWith('https')) {
                        element.mainImgUrl = element.mainImgUrl;
                     } else {
                        element.mainImgUrl = ipConfig.baseUrl+element.mainImgUrl;
                     }
                  });
                  this.tableData = data
                  this.totals = res.data.data.total
               } else {
               this.$message.error(res.data.message)
               }
          })
       },
     
       sjhsearchFor(type){
          this.posterPageDto.keyWord = type
          this.getlist(this.posterPageDto)
       },
       submitForm(formName){
         this.$set(this.operatorPosterDto, 'posterId', this.posterIdbzdid);
         this.$refs[formName].validate((valid) => {
            if (valid) {
                this.$api.hbxzxgoperatorPoster(this.operatorPosterDto).then((res) => {
                if (res.data.code == 200) {
                    this.increase = false
                    this.dialogFormVisible = false
                    this.operatorPosterDto={
                        fileId:null,
                        mainImgUrl:null,
                        posterDesc:null,
                        posterId:null,
                        posterSort:'1',
                        productIds:[],
                        remark:null,
                    }
                    this.fyposterPageDto={
                        pageNum:1,
                        pageSize:10,
                        keyWord:null,
                     },
                     this.posterIdbzdid = null
                     this.fileList = []
                     this.fytableData = []
                    this.getlist(this.posterPageDto)
                    this.$message.success(res.data.message)
                } else {
                  this.$message.error(res.data.message)
                }
              })
            } 
          });
      },
      bianjiClick(row) {
         this.posterIdbzdid = row.posterId
         this.dialogFormVisible = true;
         this.fygetlist(this.fyposterPageDto)
      },
      bjtsClick(posterId){
         this.$api.hbxqdetail({
                  posterId:posterId
            }).then((res)=>{
               if (res.data.code == 200) {
                  let data = res.data.data
                  data.posterSort = data.posterSort.toString()
                  this.fileList = []
                  if (data.mainImgUrl.startsWith('https')) {
                     data.mainImgUrl = data.mainImgUrl;
                  } else {
                     data.mainImgUrl = ipConfig.baseUrl+data.mainImgUrl;
                  }
                  this.fileList.push({
                      url: data.mainImgUrl // 更新图片的链接
                  });
                  this.operatorPosterDto  = data
                  this.$nextTick(() => {
                     this.fytableData.forEach(item => {
                        this.operatorPosterDto.productPosterVoList.forEach(element => {
                           if (item.productId == element.productId ) {
                              this.$refs.multipleTable.toggleRowSelection(item,true);
                           }
                        });
                     });
                  });
                  } else {
                     this.$message.error(res.data.message)
                  }
            })
      },
      dels(e) {
          this.$confirm('是否确认删除?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$api.hbscdelete({
               posterId:e.posterId
                }).then((res) => {
                  if(res.data.code==200){
                     this.getlist(this.posterPageDto)
                     this.$message.success(res.data.message)
                  }else{
                     this.$message.error(res.data.message)
                  }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });          
            });
        },
      handleRequest(request) {
         const formData = new FormData();
         formData.append('file', request.file); // 这里的 'file' 是后端接收文件的字段名
         this.$api.uploadPackage({
            file:request.file
         }).then((res) => {
                if (res.data.code == 200) {
                  this.$message.success(res.data.message)
                  request.onSuccess(res.data.data); // 当请求成功时，调用 onSuccess
                } else {
                    this.$message.error(res.data.message)
                }
            })
      },
      handleExceed(files, fileList) {
         this.$message.warning('已超出只能上传一张图片的限制，请先移除现有图片再上传新图片。');
      },
      // 删除图片
      handleRemove(file, fileList) {
         if (file.fileId) {
            this.$api.scwjremoveFile({
               fileId:file.fileId
            }).then((res) => {
                  if (res.data.code == 200) {
                  this.$message.success(res.data.message)
                  } else {
                     this.$message.error(res.data.message)
                  }
            })
            }
      },
      // 图片上传失败的回调函数
      handleError(error, file, fileList) {
         this.$message.error('图片上传失败');
      },
      // 上传前的处理函数
      // beforeUpload(file) {
      //   // 限制文件类型
      //   const isImage = file.type.startsWith('image/');
      //    const isVideo = file.type === 'video/mp4';
      //    if (!isImage && !isVideo) {
      //    this.$message.error('只能上传图片或 MP4 格式的视频文件');
      //    return false;
      //    }
      //    // 限制文件大小
      //    const maxSize = 30 * 1024 * 1024; // 100MB
      //    if (file.size > maxSize) {
      //    this.$message.error('文件大小不能超过 30MB');
      //    return false;
      //    }
      //    return true;
      // },
      beforeUpload(file) {
          return new Promise((resolve, reject) => {
            if (file.type.startsWith('video/mp4')) {
              resolve();
            } else if (file.type.startsWith('image')) {
              new Compressor(file, {
                quality: 0.85,        // 压缩质量，范围 0 - 1
                maxWidth: 800,       // 图片最大宽度
                maxHeight: 800,      // 图片最大高度
                mimeType: 'image/jpeg', // 强制压缩为 JPEG 格式
                success: (compressedFile) => {
                  file.compressed = compressedFile;
                  resolve();
                },
                error: (err) => {
                  console.error('图片压缩失败', err);
                  reject('图片压缩失败');
                },
              });
            } else {
              reject('只支持上传图片和 MP4 格式视频');
            }
          });
        },
      // 图片上传成功的回调函数
      handleSuccess(response, file, fileList) {
         this.operatorPosterDto.fileId = response.fileId
         this.operatorPosterDto.mainImgUrl = response.oriFileUrl
         // // 这里可以处理成功后的逻辑，例如展示上传后的图片
         this.fileList.push({
            name: file.name,
            fileId:response.fileId,
            url: response.oriFileUrl // 更新图片的链接
         });
         // this.partsAddDto.fileMetaDtos.push({
         //       fileId:response.fileId,
         //       imageType:null,
         //       imageUrl:response.oriFileUrl,
         //       positionSort:null,
         //       thumbnailUrl:null,
         // });
      },
       newoks() {
         this.increase = true
         this.fygetlist(this.fyposterPageDto)
      },
      handlepartsIdsClick(type){
         let datatype = []
         type.forEach(element => {
            datatype.push(element.productId)
         });
         this.operatorPosterDto.productIds = datatype
      },
      fygetlist(fyposterPageDto) {
          this.$api.queryProduct(fyposterPageDto)
          .then((res) => {
                if (res.data.code == 200) {
                   let data = res.data.data.records
                  data.forEach(element => {
                     if (element.productImageUrl.startsWith('https')) {
                        element.productImageUrl = element.productImageUrl;
                     } else {
                        element.productImageUrl = ipConfig.baseUrl+element.productImageUrl;
                     }
                  });
                  this.fytableData = data
                  this.fytotals = res.data.data.total
                  if (this.posterIdbzdid) {
                     this.bjtsClick(this.posterIdbzdid)
                  }
               } else {
               this.$message.error(res.data.message)
               }
          })
       },
       xxzjdan(){
         this.fygetlist(this.fyposterPageDto)
      },
      closeDialog(){
        this.xgtkdfdqx()
      },
      xgtkdfdqx(){
        this.dialogFormVisible = false;
        this.operatorPosterDto={
            fileId:null,
            mainImgUrl:null,
            posterDesc:null,
            posterId:null,
            posterSort:'1',
            productIds:[],
            remark:null,
         }
         this.fyposterPageDto={
            pageNum:1,
            pageSize:10,
            keyWord:null,
         }
         this.posterIdbzdid = null
         this.fileList = []
         this.fytableData = []
      },
      handlePreview(row) {
         this.previewImage = row.mainImgUrl;
         this.dialogVisible = true;
      },
      handleCurrentChange(val) {
         this.posterPageDto.pageNum = val
          this.getlist(this.posterPageDto)
      },
      handleSizeChange(val) {
         this.posterPageDto.pageSize = val
          this.getlist(this.posterPageDto)
      },
      fyhandleCurrentChange(val) {
         this.fyposterPageDto.pageNum = val
         this.fygetlist(this.fyposterPageDto)
      },
      fyhandleSizeChange(val) {
         this.fyposterPageDto.pageSize = val
         this.fygetlist(this.fyposterPageDto)
      },
      }
      }
   </script>
   <style scoped>
#postergl {
   width: 100%;
   height: 100%;
   overflow-y: auto;
   background-color: #fff;
   padding:0 0 0 30px;
   box-sizing: border-box;
}
.tos {
   display: flex;
   /* justify-content: space-between; */
   align-items: center;
   /* background: yellow; */
   margin-bottom: 20px;
   margin-left: -30px;
 }
 .elrow{
   box-sizing: border-box;
   width: 20%;
   margin-top: -6px;
   margin: 0 40px 0 20px;
 }
 .elrowleft{
   width: 80%;
   float: left;
   box-sizing: border-box;
 }
 .elrowleft input{
   border: 2px solid #1b93ed !important;
   border-radius: 0 !important;
   width: 100%;
   -webkit-appearance: none;
   appearance: none;
   background-color: #fff;
   background-image: none;
   border-radius: 4px;
   border: 1px solid #929da5;
   box-sizing: border-box;
   color: #1f3d35;
   font-size: 14px;
   height: 36px;
   line-height: 1;
   outline: none;
   padding: 3px 10px;
   transition: border-color .2s cubic-bezier(.645,.045,.355,1);
 }
 .elrowcontent{
   width: 16.66667%;
   float: left;
   box-sizing: border-box;
 }
 .search-btn {
   height: 36px;
   width: 100px;
   background: #1b93ed;
   border: 2px solid #1b93ed;
   margin: 0;
   padding: 0;
   color: #fff;
   cursor: pointer;
 }
 .right-item {
   margin-left: auto; /* Pushes the item to the right */
 }
 .tos /deep/ .el-form-item {
     margin-bottom: 0 !important;
 }
 .btnbox {
   /* background: pink; */
   display: flex;
   width: 40%;
   align-items: center;
   justify-content: space-around;
   margin: auto;
   margin-top: 30px;
}
.zcyhtk /deep/ .el-form-item__label {
   width: 120px !important;
}
.zcyhtk /deep/ .el-form-item__content {
   margin-left: 120px !important;
}
.fytableform{
   margin-left: 35px;
}
.image-column {
  width: 50px; /* 控制图片宽度 */
  height: 50px; /* 控制图片高度 */
  object-fit: cover; /* 保持图片比例填充 */
  cursor: pointer;
}
.el-upload__tip{
    font-size: 14px;
    color: #0889FD;
  }
   </style>


// WEBPACK FOOTER //
// src/components/marketivities/postergl.vue